// Datas de evento são gravadas como hora local do clube já em UTC, então
// formatamos em UTC — é a convenção usada no resto do projeto. Trocar para
// America/Manaus deslocaria tudo em 4 horas.
const FUSO = 'UTC';

export function formatarData(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: FUSO,
  });
}

export function formatarDataHora(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: FUSO,
  });
}

export function formatarDataLonga(valor) {
  if (!valor) return '—';
  return new Date(valor).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    timeZone: FUSO,
  });
}

export function formatarMoeda(centavos) {
  return ((centavos ?? 0) / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}
